import styled from 'styled-components';

import { H5 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const getPreparedEllipsisStyles = () => `
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 150px;
    margin: 0;
`;

export const Wrapper = styled.div`
    width: 100%;
    flex-wrap: nowrap;
    background-color: ${COLORS.BgMain};
    border-radius: 20px;
    padding: 4px;
    align-items: center;
    max-height: 56px;
    overflow: hidden;
`;

export const Icon = styled.div<{ iconSrc: string }>`
    flex: 0 0 auto;
    height: 48px;
    width: 72px;
    border-radius: ${BorderRadius.componentRadius};
    background-color: #E6EEF5;
    background-image: ${({ iconSrc }) => `url(${iconSrc})`};
    background-size: cover;
    background-position: center;
    overflow: hidden;
`;

export const DescWrap = styled.div`
    flex-direction: column;
    margin-left: 12px;
    align-self: flex-start;
    margin-top: 4px;
`;

export const Title = styled(H5)`
    color: ${COLORS.TextPrimary};
    ${getPreparedEllipsisStyles()}
`;

export const Text = styled(Paragraph5)`
    color: ${COLORS.TextInfo};
   ${getPreparedEllipsisStyles()}
`;
